import { render } from "./ProductSwiper.vue?vue&type=template&id=6d476507&scoped=true"
import script from "./ProductSwiper.vue?vue&type=script&lang=js"
export * from "./ProductSwiper.vue?vue&type=script&lang=js"

import "./ProductSwiper.vue?vue&type=style&index=0&id=6d476507&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d476507"]])

export default __exports__